"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
exports.PaginationButton = (0, styled_components_1.default)((props) => react_1.default.createElement('button', (0, helpers_1.clearProps)(props))) `
    width: ${helpers_1.SPACING_L};
    height: ${helpers_1.SPACING_L};
    border: none;
    display: flex;
    padding: 0;
    margin: 0;
    background-color: transparent;

    &:active,
    &:focus,
    &:hover {
        outline: none;
    }

    ${({ theme }) => (0, styled_components_1.css) `
        &:hover {
            background-color: ${theme.colorHighlightLight};
        }

        &:active {
            background-color: ${theme.colorHighlightDark};
        }

        &:disabled {
            background-color: transparent;

            & > svg {
                color: ${theme.colorControlIconDisabled};
            }
        }
    `}
`;
//# sourceMappingURL=PaginationButton.js.map